import React, { useEffect, useState } from 'react';
import Tabs from 'cccisd-tabs';
import Tooltip from 'cccisd-tooltip';
import { client as apollo } from 'cccisd-apollo';
import axios from 'cccisd-axios';
import _uniqBy from 'lodash/uniqBy';
import DomainTables from './DomainTables';
import mockup from './dashboard.png';
import IconConstruction from 'cccisd-icons/construction';
import assignmentMetricsQuery from '../../queries/assignmentMetricsQuery.graphql';
import { assign } from 'lodash';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;
const Dashboard = () => {
    const [metrics, setMetrics] = useState(null);
    useEffect(() => {
        getAssignmentData();
    }, []);

    const getAssignmentData = async () => {
        try {
            const result = await apollo.query({
                query: assignmentMetricsQuery,
                fetchPolicy: 'network-only',
                variables: {
                    assignmentId: 26,
                    limit: 10000,
                },
            });

            if (!result.data.metrics) {
                // setShow404(true);
                // setIsLoading(false);
                return;
            }

            const computedMetrics = _uniqBy(result.data.metrics.variableList, 'reportHeader').reduce((acc, item) => {
                acc[item.reportHeader] = {
                    reportHeader: item.reportHeader,
                    type: item.type,
                    question: item.key.title,
                    questionType: item.key.questionType,
                    isIdentifying: Boolean(item?.key?.isIdentifying),
                };
                return acc;
            }, {});
            console.log('computedMetrics', computedMetrics);
            // index by the assignmentId used for the query (26)
            setMetrics(prev => ({ ...(prev || {}), 26: computedMetrics }));
        } catch (error) {
            // setShow404(true);
        }

        // This uses the backend route which is just doing a graphql query
        // const response = await axios.get(
        //     Boilerplate.route('api.assignment.metrics.customVariableList', { assignmentId: 26 })
        // );

        // console.log('response', response);
        // // we need deduplicate list as we could have the same reportHeader for different languages
        // const metrics = _uniqBy(response.data.data.metrics.variableList, 'reportHeader').reduce(
        //     (acc, item) => {
        //         acc[item.reportHeader] = {
        //             reportHeader: item.reportHeader,
        //             surveyHandles: item.surveyHandles,
        //             type: item.type,
        //             label: item.label,
        //             question: item.key.title,
        //             questionType: item.key.questionType,
        //             isIdentifying: Boolean(item?.key?.isIdentifying),
        //             isFile: item.tagList.some(
        //                 obj => obj.scope === 'system' && obj.handle === 'fileUpload'
        //             ),
        //         };
        //         return acc;
        //     },
        //     {}
        // );
        // console.log('metrics', metrics);
    };

    const tabList = [
        {
            name: 'secondTab',
            title: (
                <Tooltip title="Shows scores to each survey item for each individual caregiver and/or youth, grouped by domain.">
                    Individual Data
                </Tooltip>
            ),
            content: <DomainTables />,
        },
        {
            name: 'firstTab',
            title: 'Aggregate Data',
            content: (
                <div style={{ marginTop: '1em', marginLeft: '1em' }}>
                    <div className="alert alert-danger" style={{ textAlign: 'center', width: '1180px' }}>
                        <h3>
                            <IconConstruction spaceRight />
                            Under Construction (not actual data)
                        </h3>
                        <p>Select Individual Data above to see dashboards for live Indivdual Respondent Data.</p>
                        <p>
                            Please note this tab is still in development and you are looking at a rough draft of what
                            the first tab may eventually look like.
                        </p>
                    </div>
                    <img src={mockup} alt="Stage 3 mockup" style={{ height: '1080px' }} />
                </div>
            ),
        },
    ];
    console.log('metrics in dashboard', metrics);
    return (
        <div style={{ marginTop: '2rem' }}>
            <Tabs tabList={tabList} />
        </div>
    );
};

export default Dashboard;
